export function MedicalCross(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M4.5 3h15" />
        <path
          d="M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"
          style={{
            fill: 'none',
          }}
        />
        <path d="M6 14h12" />
      </svg>
    </div>
  );
}
